import { render, staticRenderFns } from "./polygon.vue?vue&type=template&id=cefadf1a&scoped=true&"
import script from "./polygon.vue?vue&type=script&lang=js&"
export * from "./polygon.vue?vue&type=script&lang=js&"
import style0 from "./polygon.vue?vue&type=style&index=0&id=cefadf1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefadf1a",
  null
  
)

export default component.exports